import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import * as _ from 'lodash';
import { NotifyService } from '../services/notify.service';
import { Observable, Subject } from 'rxjs';
import { ToastrService } from '../services/toastr.service';
import { TranslateService } from '@ngx-translate/core';

export interface CanComponentDeactivateReport {
    canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class ReportGuard implements CanDeactivate<CanComponentDeactivateReport> {
    _reportSubscribe;
    savedComments: Boolean = true;
    observable;
    private _subject: Subject<any>;
    observer: Observable<any>;

    constructor(private notifyService: NotifyService, private toasterService: ToastrService, private translateService: TranslateService) {
        this._subject = new Subject<any>();
        this.observer = this._subject.asObservable();
        this._reportSubscribe = this.notifyService.observer.subscribe(res => {
            if (_.get(res, 'key') === 'saved-comments') {
                this.savedComments = _.get(res, 'data');
            }
            else if (_.get(res, 'key') === 'response-modal-comments') {
                this.notifyService.notify({ key: 'modal-comments', data: false });
                this.notifyFlow(_.get(res, 'data'));
            }

        });
    }
    canDeactivate(component: CanComponentDeactivateReport) {
        if (!this.savedComments) {
            this.notifyService.notify({
                key: 'modal-comments',
                data: true,
                modal: { title: 'REPORTS.MODAL.TITLE', question: 'REPORTS.MODAL.QUESTION', subquestion: 'REPORTS.MODAL.SUBQUESTION' }
            });

            return this.observer
        }
        return component.canDeactivate ? component.canDeactivate() : true;
    }

    notifyFlow(data) {
        this._subject.next(data);
    }
}